exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content > .block {\n  padding: 5px 25px 20px; }\n  .content > .block.empty-reviews {\n    padding: 20px 25px 20px; }\n  .content > .block .flex-item.text {\n    padding: 15px 0;\n    -ms-flex-item-align: center;\n        -ms-grid-row-align: center;\n        align-self: center; }\n  .content > .block .flex-item.review-btn {\n    padding: 20px; }\n  .content > .block p {\n    margin: none;\n    margin: unset; }\n\nul.flex {\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  ul.flex li.flex.block {\n    padding: 0 25px; }\n\n.block {\n  text-align: center; }\n  .block p {\n    text-align: justify; }\n\n@media (min-width: 320px) and (max-width: 480px) {\n  .flex-container > .flex-item.text {\n    padding: unset !important; }\n  .flex-container > .flex-item.review-btn {\n    padding: 10px !important; } }\n\n@media (min-width: 320px) and (max-width: 767px) {\n  .flex-container {\n    -ms-flex-direction: column;\n        flex-direction: column; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/feed.component.scss
// module id = ../../../../../src/app/pages/feed.component.scss
// module chunks = main